import type { TrendingSearchTranslationEntity } from './TrendingSearchTranslationEntity'

export class TrendingSearchEntity {
  id?: number
  channelId?: number | null
  channelName?: string | null
  channel?: {
    id?: number
    name?: string | null
  }
  translations?: Array<TrendingSearchTranslationEntity> | null
}
